/**
 * Responsive equal Height
 */

function init() {
	$(".js-account ").responsiveEqualHeights(".js-account-item", ".js-account-item__title");
	$(".js-account ").responsiveEqualHeights(".js-account-item", ".js-account-item__description");
}

export { init };
